<template>
	<div id="editorView" v-if="notification !== undefined">
		<div id="sidebar">
			<!-- Strip 1 -->
			<div class="sidebar-strip-1">
				<div class="sidebar-group-top">
					<!-- <button
						type="button"
						class="button-sb small"
						:class="{ 'active': currentState === 'template-select' }"
						@click="setState('TEMPLATE_SELECT')"
					>
						<img src="../assets/img/icons/editor/round-dashboard-24px.svg" />
						<label>Templates</label>
					</button>-->
					<button
						type="button"
						class="button-sb small"
						:class="{ 'active': currentState === 'add-edit' || currentState === 'layer-edit' || currentState === 'sound-edit' || currentState === 'background-edit' }"
						@click="setState('ADD_EDIT')"
					>
						<img src="../assets/img/icons/editor/baseline-edit-24px.svg" />
						<label>Edit</label>
					</button>
				</div>
				<div class="sidebar-group-bottom">
					<button type="button" class="button-sb small" @click="undo" :disabled="!historyExists">
						<img src="../assets/img/icons/editor/round-undo-24px.svg" />
						<label>Undo</label>
					</button>
					<button
						type="button"
						class="button-sb small"
						@click="saveNotification"
						:disabled="loading.save || !save_timeout"
					>
						<img src="../assets/img/icons/editor/round-save-24px.svg" />
						<label v-if="loading.save">Saving</label>
						<label v-else-if="save_timeout">Save</label>
						<label v-else>Saved</label>
					</button>
					<!-- <button type="button" class="button-sb small" @click="() => { return false }">
						<img src="../assets/img/icons/editor/round-settings-24px.svg" />
						<label>Settings</label>
					</button>-->
				</div>
			</div>
			<!-- Strip 2 -->
			<div class="sidebar-strip-2">
				<!-- Selected layer controls -->
				<div id="layerSidebar" :class="{ 'out-right': currentState !== 'layer-edit' }">
					<div class="sidebar-group">
						<div class="button-group-4">
							<button type="button" class="button-icon" @click="setState('ADD_EDIT')" title="Go back">
								<img src="../assets/img/icons/editor/round-arrow_back-24px.svg" />
							</button>
							<span></span>
							<button
								type="button"
								class="button-icon"
								@click="cloneLayer(notification, selectedLayer)"
								title="Duplicate layer"
							>
								<img src="../assets/img/icons/editor/outline-file_copy-24px.svg" />
							</button>
							<button
								type="button"
								class="button-icon"
								@click="removeLayer(notification, selectedLayer)"
								title="Delete layer"
							>
								<img src="../assets/img/icons/editor/round-delete_outline-24px.svg" />
							</button>
						</div>
					</div>
					<div class="sidebar-group" v-if="selectedLayer">
						<div>
							<label>Type</label>
							<InfoTooltip>Layers should be dynamic if you plan to pass custom content to them via the Gleebeam API</InfoTooltip>
						</div>
						<div class="radio-group-2" :key="keys.sidebar.layerDynamicToggle">
							<input
								id="staticType"
								type="radio"
								name="layerType"
								:checked="!selectedLayer.dynamic"
								@input="applyChange(() => { setLayerDynamic(selectedLayer, false) })"
							/>
							<label for="staticType" class="radio-label">
								<span>Static</span>
							</label>
							<input
								id="dynamicType"
								type="radio"
								name="layerType"
								:checked="selectedLayer.dynamic"
								@input="applyChange(() => { setLayerDynamic(selectedLayer, true) })"
							/>
							<label for="dynamicType" class="radio-label">
								<span>Dynamic</span>
							</label>
						</div>
						<div v-if="selectedLayer.dynamic">
							<div>
								<label for="layerNameInput">Name</label>
								<InfoTooltip>Naming layers will help you identify them when passing custom content to them</InfoTooltip>
							</div>
							<input
								id="layerNameInput"
								type="text"
								v-model="selectedLayer.name"
								@input="selectedLayer.handleDataChange()"
								@blur="applyChange(onLayerNameBlur(notification))"
							/>
						</div>
					</div>
					<!-- <label for="layerValueInput">Value</label>
					<input
						v-if="selectedLayer"
						id="layerValueInput"
						type="text"
						:value="selectedLayer.value"
						@input="selectedLayer.value = $event.target.value"
						@blur="applyChange()"
					/>-->
					<div class="sidebar-group separator" v-if="selectedLayer && selectedLayer.type === 'text'">
						<label>Font</label>
						<Select
							class="select dark"
							:menu_offset="{ top: 40 }"
							:trigger_style="{ 'max-width': '120px', 'text-overflow': 'ellipsis', 'overflow': 'hidden',	'white-space': 'nowrap' }"
						>
							<template v-slot:trigger>
								<span>
									<span>{{ selectedLayer.style.fontFamily }}</span>
								</span>
							</template>
							<template v-slot:options>
								<div
									v-for="font in config.text.fonts"
									:key="font"
									:style="{ 'font-family': `'${font}'` }"
									@click="selectedLayer.style.fontFamily = font"
								>{{ font }}</div>
							</template>
						</Select>
						<label>Size</label>
						<SliderBox
							v-if="selectedLayer && selectedLayer.type.includes('text')"
							:value="selectedLayer.style.fontSize"
							@input="selectedLayer.style.fontSize = $event"
							@inputend="applyChange()"
							units="px"
							:min="config.text.minFontSize"
							custom_class="dark"
							:disabled="selectedLayer === undefined || !selectedLayer.type.includes('text')"
						/>
						<label>Color</label>
						<ColorPicker
							v-if="selectedLayer"
							:value="selectedLayer ? selectedLayer.style.color : null"
							@input="applyChange(() => { selectedLayer.style.color = $event })"
							:disabled="selectedLayer === undefined || !selectedLayer.type.includes('text')"
						></ColorPicker>
						<label>Alignment</label>
						<div class="button-group-3">
							<button
								type="button"
								class="button-icon"
								:class="{ 'active': selectedLayer.style.textAlign === 'left' }"
								@click="applyChange(() => { selectedLayer.textAlign = 'left' })"
							>
								<img src="../assets/img/icons/editor/round-format_align_left-24px.svg" />
							</button>
							<button
								type="button"
								class="button-icon"
								:class="{ 'active': selectedLayer.style.textAlign === 'center' }"
								@click="applyChange(() => { selectedLayer.textAlign = 'center' })"
							>
								<img src="../assets/img/icons/editor/round-format_align_center-24px.svg" />
							</button>
							<button
								type="button"
								class="button-icon"
								:class="{ 'active': selectedLayer.style.textAlign === 'right' }"
								@click="applyChange(() => { selectedLayer.textAlign = 'right' })"
							>
								<img src="../assets/img/icons/editor/round-format_align_right-24px.svg" />
							</button>
						</div>
						<div>
							<label>Autoscroll</label>
							<InfoTooltip>Text that exceeds field boundaries will be scrolled automatically in the dashboard</InfoTooltip>
						</div>
						<div class="radio-group-2" :key="keys.sidebar.layerAutoscrollToggle">
							<input
								id="autoscrollOff"
								type="radio"
								name="layerAutoscroll"
								:checked="!selectedLayer.autoscroll"
								@input="applyChange(() => { selectedLayer.autoscroll = false })"
							/>
							<label for="autoscrollOff" class="radio-label">
								<span>Off</span>
							</label>
							<input
								id="autoscrollOn"
								type="radio"
								name="layerAutoscroll"
								:checked="selectedLayer.autoscroll"
								@input="applyChange(() => { selectedLayer.autoscroll = true })"
							/>
							<label for="autoscrollOn" class="radio-label">
								<span>On</span>
							</label>
						</div>
					</div>
					<div class="sidebar-group separator" v-if="selectedLayer">
						<!-- <label>Width</label>
						<SliderBox
							:value="selectedLayer.style.width"
							@input="selectedLayer.style.width = $event"
							@inputend="applyChange()"
							units="px"
							:min="config[selectedLayer.type].minWidth"
							custom_class="dark"
						/>-->
						<label>Rotation</label>
						<SliderBox
							:value="selectedLayer.style.rotation"
							@input="selectedLayer.style.rotation = $event"
							@inputend="applyChange()"
							units="deg"
							custom_class="dark"
						/>
					</div>
					<!-- <div>
						<label for="layerLineHeightInput">Line spacing:</label>
						<input
							v-if="selectedLayer"
							id="layerLineHeightInput"
							type="number"
							min="0.8"
							max="2"
							step="0.1"
							:value="selectedLayer.style.lineHeight"
							@input="selectedLayer.style.lineHeight = $event.target.value"
							@blur="applyChange()"
							:disabled="selectedLayer === undefined || !selectedLayer.type.includes('text')"
						/>
					</div>-->
					<!-- <label>Position</label>
					<div>
						<button
							type="button"
							@click="applyChange(() => { selectedLayer.center(notificationViewCenter) })"
						>Center</button>
					</div>-->
					<div class="sidebar-group separator">
						<label>Depth</label>
						<div class="button-group-2">
							<button
								type="button"
								class="button-icon background"
								@click="applyChange(() => { notification.setLayerDepth(selectedLayer, 'down') })"
								:disabled="selectedLayer === undefined"
								title="Send layer backwards"
							>
								<img
									src="../assets/img/icons/editor/round-arrow_back-24px.svg"
									style="transform: rotate(270deg)"
								/>
							</button>
							<button
								type="button"
								class="button-icon background"
								@click="applyChange(() => { notification.setLayerDepth(selectedLayer, 'up') })"
								:disabled="selectedLayer === undefined"
								title="Bring layer forward"
							>
								<img
									src="../assets/img/icons/editor/round-arrow_back-24px.svg"
									style="transform: rotate(90deg)"
								/>
							</button>
						</div>
					</div>
				</div>
				<!-- Add / edit strip -->
				<div :class="{ 'out-left': currentState !== 'add-edit' && currentState !== 'image-select' }">
					<div class="sidebar-group">
						<h6>Add</h6>
						<button type="button" class="button-sb big" @click="setState('IMAGE_SELECT')">
							<img src="../assets/img/icons/editor/outline-image-24px.svg" />
							<label>Image</label>
						</button>
						<button type="button" class="button-sb big" @click="addLayer(notification, { type: 'text' })">
							<img src="../assets/img/icons/editor/outline-text_fields-24px.svg" />
							<label>Text</label>
						</button>
					</div>
					<div class="sidebar-group separator">
						<h6>Modify</h6>
						<button type="button" class="button-sb big" @click="setState('BACKGROUND_EDIT')">
							<img src="../assets/img/icons/editor/outline-texture-24px.svg" />
							<label>Background</label>
						</button>
						<button type="button" class="button-sb big" @click="setState('SOUND_EDIT')">
							<img src="../assets/img/icons/editor/round-sound-24px.svg" />
							<label>Sound</label>
						</button>
					</div>
				</div>
				<!-- Edit background strip -->
				<div id="backgroundSidebar" :class="{ 'out-right': currentState !== 'background-edit' }">
					<div class="sidebar-group">
						<div class="button-group-4">
							<button type="button" class="button-icon" @click="setState('ADD_EDIT')">
								<img src="../assets/img/icons/editor/round-arrow_back-24px.svg" />
							</button>
							<span></span>
							<span></span>
							<span></span>
						</div>
					</div>
					<div class="sidebar-group">
						<label>Color</label>
						<ColorPicker
							:value="notification.background_color"
							@input="applyChange(() => { notification.background_color = $event })"
						></ColorPicker>
					</div>
				</div>
				<!-- Edit sound strip -->
				<div id="soundSidebar" :class="{ 'out-right': currentState !== 'sound-edit' }">
					<div class="sidebar-group">
						<div class="button-group-4">
							<button type="button" class="button-icon" @click="setState('ADD_EDIT')">
								<img src="../assets/img/icons/editor/round-arrow_back-24px.svg" />
							</button>
							<span></span>
							<span></span>
							<span></span>
						</div>
					</div>
					<div class="sidebar-group">
						<div>
							<label>Sound effect</label>
							<p>Use sound effects in moderation as they can be distracting</p>
						</div>
						<div id="soundContainer">
							<div class="sound-radio-item">
								<input
									id="noSoundInput"
									type="radio"
									class="sound-radio-input"
									:checked="notification.sound.name === 'None'"
									@input="applyChange(() => { setNotificationSound({ enabled: false, name: 'None', filename: null }) })"
								/>
								<label for="noSoundInput" class="sound-radio-label">None</label>
							</div>
							<div class="sound-radio-item" v-for="sound in config.sounds" :key="sound.filename">
								<input
									type="radio"
									class="sound-radio-input"
									:id="sound.filename"
									:checked="notification.sound.name === sound.name"
									@input="applyChange(() => { setNotificationSound({ enabled: true, ...sound }) })"
								/>
								<label :for="sound.filename" class="sound-radio-label">{{ sound.name }}</label>
								<img
									v-if="currentlyPlayingSounds.includes(sound.filename)"
									src="../assets/img/icons/editor/round-volume_up-24px.svg"
									width="18"
									height="18"
								/>
								<img
									v-else
									src="../assets/img/icons/editor/play_arrow-24px.svg"
									width="18"
									height="18"
									@click="playSound(sound.filename)"
								/>
							</div>
						</div>
						<div ref="soundPlayerContainer" style="visibility: hidden"></div>
					</div>
				</div>
			</div>
		</div>
		<header id="editorHeader">
			<input
				id="notificationNameInput"
				class="big"
				type="text"
				:value="notification.name"
				@input="notification.name = $event.target.value"
				@blur="applyChange(() => { if (notification.name.length === 0) notification.name = 'Untitled notification' })"
			/>
			<button class="button primary" type="button" @click="exit" :disabled="loading.save">
				<label v-if="!loading.save">Save & Exit</label>
				<label v-else>Saving...</label>
			</button>
			<transition name="zoom-fade">
				<Banner
					v-if="$_banner_active"
					class="error"
					style="top: 72px"
					@actionClick="banner.onaction"
					@dismiss="$_banner_hide"
				>
					<template v-slot:message>{{ banner.message }}</template>
					<template v-slot:action>{{ banner.action }}</template>
				</Banner>
			</transition>
		</header>
		<div
			id="notificationViewWrapper"
			@mousedown="mousedown"
			@touchstart="mousedown"
			@mouseup="mouseup"
			@touchend="mouseup"
			@mousemove="mousemove($event)"
			@touchmove="mousemove($event)"
			:style="{ 'background-color': notification.background_color }"
		>
			<NotificationView
				ref="notificationView"
				id="notificationView"
				:notification="notification"
				:editable="true"
				:responsive="false"
				@layerSelect="selectLayerAndStartDrag($event.layer, $event.mouse_event)"
				@textLayerInput="onTextInput($event.layer)"
				@textLayerBlur="applyChange()"
			/>
		</div>
		<transition name="fade">
			<ImageModal v-if="this.currentState === 'image-select'" @input="handleImageModal($event)" />
		</transition>
	</div>
</template>

<script>
import uniqid from "uniqid";
import ColorPicker from "./input/color-picker";
import Config from "../modules/editor.config";
import State from "../modules/editor-state";
import { setTimeout, clearTimeout } from "timers";
import SliderBox from "./input/slider-box";
import NotificationView from "./notification-view";
import InfoTooltip from "./overlay/info-tooltip";
import ImageModal from "./overlay/image-modal";
import Select from "./input/select";

import Banner from "./overlay/banner";
import BannerMixin from "@/mixins/banner-mixin";

export default {
	data() {
		return {
			loading: {
				save: false
			},
			state: null,
			save_timeout: null,
			editModeInitialized: false,
			historyExists: false,
			keys: {
				sidebar: {
					layerDynamicToggle: 0,
					layerAutoscrollToggle: 0
				}
			},
			currentlyPlayingSounds: []
		};
	},
	mixins: [BannerMixin],
	components: {
		ColorPicker,
		SliderBox,
		NotificationView,
		InfoTooltip,
		ImageModal,
		Select,
		Banner
	},
	props: {
		notificationId: {
			type: String,
			required: true
		}
	},
	computed: {
		user() {
			return this.$store.getters.user;
		},
		notification() {
			return this.$store.getters.getNotificationById(this.notificationId);
		},
		notificationViewCenter() {
			const element = this.$refs.notificationView.$el;
			const rect = element.getBoundingClientRect();

			const x = rect.width / 2;
			const y = rect.height / 2;

			return { x, y };
		},
		selectedLayer() {
			return this.notification ? this.notification.selectedLayer : null;
		},
		config() {
			return Config;
		},
		currentState() {
			return this.state ? this.state.current : null;
		}
	},
	watch: {
		notification() {
			if (!this.editModeInitialized) {
				this.$nextTick(this.initializeEditMode);
			}
		},
		selectedLayer(value) {
			if (value) this.setState("LAYER_EDIT");
			else this.setState("ADD_EDIT");
		},
		currentState(value) {
			if (this.notification && value === "add-edit")
				this.notification.deselectLayers();
		}
	},
	methods: {
		setState(state) {
			this.state.current = State.states[state];
		},
		async saveNotification(delay = 0) {
			clearTimeout(this.save_timeout);

			if (delay > 0) {
				this.save_timeout = setTimeout(this.saveNotification, delay);
			} else {
				this.loading.save = true;

				await this.$db()
					.collection("notifications")
					.doc(this.notification.id)
					.update({
						name: this.notification.name,
						template: this.notification.template.map(
							layer => layer.dataAsObject
						),
						enabled: this.notification.enabled,
						background_color: this.notification.background_color,
						sound: this.notification.sound,
						date_edited: Date.now()
					});

				this.loading.save = false;
				this.save_timeout = null;

				console.log("Notification saved."); // eslint-disable-line no-console
			}
		},
		initializeEditMode() {
			if (this.notification !== undefined && !this.editModeInitialized) {
				this.populateLayerElementReferences();

				this.$store.commit("saveNotificationState", {
					notification_id: this.notification.id,
					data: this.notification.dataAsObject
				});
			}
		},
		populateLayerElementReferences() {
			this.notification.template.forEach(layer => {
				layer.elementReference = this.$refs.notificationView.$refs[
					layer.id
				][0];
			});
		},
		applyChange(change) {
			const state = this.$store.getters.getMostRecentNotificationState(
				this.notification.id
			);

			if (change) change();

			if (this.notification.changed(state)) {
				this.pushUndoHistory();
				this.saveNotification(this.config.autosave.delay);
			}
		},
		addLayer(notification, { type, value, value_still }) {
			const layerId = uniqid.time();

			let layerConfig = {
				id: layerId,
				name: `${type}-${layerId}`,
				type: type,
				dynamic: false,
				style: {
					position: {
						column: {
							start: 3,
							end: 5
						},
						row: {
							start: 3,
							end: 5
						}
					},
					rotation: 0
				}
			};

			switch (type) {
				case "text":
					layerConfig.autoscroll = true;
					layerConfig.style.fontSize = this.config.text.fontSize;
					layerConfig.style.fontFamily = this.config.text.fontFamily;
					layerConfig.style.color = this.config.text.color;
					layerConfig.style.textAlign = this.config.text.textAlign;
					layerConfig.style.lineHeight = this.config.text.lineHeight;
					break;

				case "image":
					layerConfig.value = value;
					layerConfig.value_still = value_still;
					break;
			}

			let layer = this.notification.addLayer(layerConfig);

			this.$nextTick(() => {
				layer.elementReference = this.$refs.notificationView.$refs[
					layer.id
				][0];

				layer.center(this.notificationViewCenter);
				if (layer.type === "image")
					layer.centerOnLoad(this.notificationViewCenter);

				this.notification.deselectLayers();
				layer.selected = true;

				this.applyChange();
			});
		},
		removeLayer(notification, layer) {
			notification.removeLayer(layer);

			this.applyChange();
		},
		cloneLayer(notification, layer) {
			const clone = layer.dataAsObject;

			clone.id = uniqid.time();
			clone.name += "-copy";

			let clonedLayer = notification.addLayer(clone);

			this.$nextTick(() => {
				clonedLayer.elementReference = this.$refs.notificationView.$refs[
					clonedLayer.id
				][0];

				this.notification.deselectLayers();
				clonedLayer.selected = true;

				this.applyChange();
			});
		},
		setLayerDynamic(layer, state) {
			if (state) {
				const permit = this.validateLayerDynamicStateChage();

				if (!permit) {
					// re-render element
					this.keys.sidebar.layerDynamicToggle++;
					// eslint-disable-next-line no-console
					this.$_banner_show({
						message:
							"The Basic plan is limited to a single dynamic layer per template.",
						action: "See pricing options",
						onaction: () => this.$parent.$emit("showPricingPlans")
					});
					return;
				}
			}

			layer.dynamic = state;
		},
		validateLayerDynamicStateChage() {
			const planData = this.user.plan_data;
			if (planData.limits && planData.limits.dynamic_fields) {
				if (
					this.notification.dynamicLayerCount >=
					planData.limits.dynamic_fields
				)
					return false;
				else return true;
			} else return true;
		},
		handleImageModal(event) {
			if (event.success)
				this.addLayer(this.notification, {
					type: "image",
					value: event.image_url,
					value_still: event.still_url
				});
			else this.setState("ADD_EDIT");
		},
		async exit() {
			await this.saveNotification();
			this.$router.push("/templates");
		},
		pushUndoHistory() {
			this.$store.commit("saveNotificationState", {
				notification_id: this.notification.id,
				data: this.notification.dataAsObject
			});
			this.historyExists = this.$store.getters.notificationHistoryExists(
				this.notificationId
			);
		},
		undo() {
			const previousState = this.$store.getters.getPreviousNotificationState(
				this.notification.id
			);

			this.notification.apply(previousState);
			this.$nextTick(this.populateLayerElementReferences);
			this.saveNotification(this.config.autosave.delay);

			this.historyExists = this.$store.getters.notificationHistoryExists(
				this.notificationId
			);
		},
		selectLayerAndStartDrag(layer, event) {
			if (event.target !== document.activeElement) {
				event.preventDefault();
				document.activeElement.blur();

				this.notification.deselectLayers();

				layer.setInteractionStartParams({
					mouseX: event.clientX || event.touches[0].clientX,
					mouseY: event.clientY || event.touches[0].clientY
				});

				this.$nextTick(() => {
					layer.selected = true;
					layer.dragged = true;
				});
			}
		},
		mousedown() {
			this.notification.deselectLayers();
		},
		mousemove(event) {
			let draggedLayer = this.notification.draggedLayer;
			let resizedLayer = this.notification.resizedLayer;
			let rotatedLayer = this.notification.rotatedLayer;

			if (resizedLayer) resizedLayer.resizeInGrid(event);
			else if (draggedLayer) {
				draggedLayer.dragInGrid(event);

				let snappedPosition = this.snapToCenter({
					layer: draggedLayer,
					sensitivityThreshold: 8
				});

				draggedLayer.position = snappedPosition;
			} else if (rotatedLayer) rotatedLayer.rotate(event);
		},
		mouseup() {
			this.notification.deactivateLayerDrag();
			this.notification.deactivateLayerResize();
			this.notification.deactivateLayerRotation();

			this.applyChange();
		},
		onTextInput(layer) {
			layer.handleTextInput();
		},
		snapToCenter({ layer, sensitivityThreshold }) {
			// rect required to get element height only
			const layerRect = layer.rect;
			// the center point in this case will always be the notification area center
			const center = this.notificationViewCenter;

			let layerPosition = {
				top: layer.style.top,
				left: layer.style.left
			};
			// width
			const elementCenterX = layer.style.left + layer.style.width / 2;
			const deltaX = Math.abs(center.x - elementCenterX);

			if (deltaX < sensitivityThreshold)
				layerPosition.left = center.x - layer.style.width / 2;
			// height
			const elementCenterY = layer.style.top + layerRect.height / 2;
			const deltaY = Math.abs(center.y - elementCenterY);

			if (deltaY < sensitivityThreshold)
				layerPosition.top = center.y - layerRect.height / 2;

			return layerPosition;
		},
		keyEventHandler(event) {
			// capture delete and backspace keys and remove selected layer if there is one
			if (
				this.selectedLayer &&
				(document.activeElement.tagName !== "INPUT" &&
					document.activeElement.tagName !== "TEXTAREA") &&
				(event.key === "Delete" || event.key === "Backspace")
			)
				this.removeLayer(this.notification, this.selectedLayer);
		},
		onLayerNameBlur(notification) {
			notification.removeEmptyLayerNames();
			notification.enforceUniqueLayerNames();
		},
		setNotificationSound(soundData) {
			this.notification.sound.enabled = soundData.enabled;
			this.notification.sound.name = soundData.name;
			this.notification.sound.filename = soundData.filename;

			this.playSound(soundData.filename);
		},
		playSound(filename) {
			const player = document.createElement("audio");
			const source = document.createElement("source");

			player.onended = () => {
				this.$refs.soundPlayerContainer.removeChild(player);
				this.currentlyPlayingSounds.splice(
					this.currentlyPlayingSounds.indexOf(filename),
					1
				);
			};
			source.src = `/sfx/${filename}`;

			player.appendChild(source);
			this.$refs.soundPlayerContainer.appendChild(player);

			this.currentlyPlayingSounds.push(filename);

			this.$nextTick(async () => {
				await player.load();
				await player.play();
			});
		}
	},
	created() {
		this.state = new State({ current: State.states.ADD_EDIT });
	},
	mounted() {
		this.$nextTick(() => {
			this.initializeEditMode();
		});

		document.addEventListener("keyup", this.keyEventHandler, true);
	},
	beforeDestroy() {
		clearTimeout(this.save_timeout);
		document.removeEventListener("keyup", this.keyEventHandler, true);
	}
};
</script>

<style>
#editorView {
	position: relative;
	padding-left: var(--editor-sidebar-width);
}
#sidebar {
	position: fixed;
	width: var(--editor-sidebar-width);
	height: 100%;
	left: 0;
	z-index: 666;
	overflow: visible;
}

#editorHeader {
	position: relative;

	justify-content: space-between;
}

.sidebar-strip-1 {
	width: var(--editor-sidebar-strip1-width);
	height: 100%;
	float: left;
	background-color: var(--dark-black);
	color: white;
	display: flex;
	flex-flow: column;
	justify-content: space-between;
}

.sidebar-group-top {
	border-bottom: 1px solid var(--separator-white);
}

.sidebar-group-bottom {
	border-top: 1px solid var(--separator-white);
}

.sidebar-strip-2 {
	position: relative;
	width: var(--editor-sidebar-strip2-width);
	height: 100%;
	float: right;
	background-color: var(--light-black);
	overflow-x: hidden;
	overflow-y: auto;
}

.sidebar-strip-2 > div {
	position: absolute;
	width: var(--editor-sidebar-strip2-width);
	top: 0;
	left: 0;
	transition: left 0.2s ease-out;
}

.sidebar-strip-2 > div.out-left {
	left: calc(var(--editor-sidebar-strip2-width) * -1);
}

.sidebar-strip-2 > div.out-right {
	left: var(--editor-sidebar-strip2-width);
}

/* .sidebar-strip-2 .sidebar-group:not(:first-child) {
	border-top: 1px solid var(--separator-white);
} */

#layerSidebar > div:first-child,
#backgroundSidebar > div:first-child,
#soundSidebar > div:first-child {
	margin-top: 16px;
	padding: 0 8px;
}

.sidebar-group {
	display: flex;
	flex-flow: column;
	padding: 0px 8px 24px 8px;
}

.sidebar-group.separator {
	border-top: 1px solid var(--separator-white);
}

.sidebar-group > h6 {
	font-weight: bold;
	align-self: center;
	font-size: 14px;
	line-height: 19px;
	color: white;
	opacity: 0.6;
	padding: 0;
	margin: 16px 0 8px 0;
}

#editorView > #notificationViewWrapper {
	position: relative;
	width: 100%;
	height: calc(100vh - 72px);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}

#notificationView {
	position: relative;
}

#editorView #notificationView {
	/* border: 2px solid var(--dark-black); */

	padding: 8px;
}

#soundSidebar p {
	margin: 4px 0 4px 0;

	font-family: Nunito;
	font-size: 14px;
	line-height: 19px;

	color: rgba(255, 255, 255, 0.6);
}

.sound-radio-item {
	display: grid;
	grid-template-columns: 24px 1fr 24px;
	align-items: center;

	height: 36px;

	padding: 0 4px;

	border-radius: 4px;
}

.sound-radio-item:hover {
	background-color: var(--lighter-black);
}

.sound-radio-input {
	height: 100%;
}

.sound-radio-label {
	padding: 8px 0;

	font-weight: 600;
	font-size: 14px;
	line-height: 19px;

	margin: 0;

	max-width: 88px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.sound-radio-item > img {
	opacity: 0.87;
}
.sound-radio-item > img:hover {
	opacity: 1;
}
</style>
